// Анимация прокрутки чисел при скроле экрана до этого блока.
itsoftApp.createModule("numbersAnimation", function() {

    if ($(".stat-info").length) {

        var windowHeight = $(window).height(),
            statInfoPosition = $(".stat-info").offset().top,
            windowPosition = $(window).scrollTop(),
            windowPositionBottom = windowPosition + windowHeight,
            checkRun = true;

        if (windowPositionBottom > statInfoPosition && checkRun) {
            runNum();
            checkRun = false;
        }

        $(window).scroll(function() {
            var windowPosition = $(this).scrollTop(),
                windowPositionBottom = windowPosition + windowHeight;
                if (windowPositionBottom > statInfoPosition && checkRun) {
                    runNum();
                    checkRun = false;
                }
        });

        function runNum() {
            $(".stat-info__col").addClass("show");
            $(".stat-info__spacer").addClass("show");
            $('.stat-info__number').each(function() {
                var startNum = ($(this).text() - 30);
                $(this).prop('Counter', startNum).animate({
                    Counter: $(this).text()
                }, {
                    duration: 2000,
                    easing: 'swing',
                    step: function (now) {
                        $(this).text(Math.ceil(now));
                    }
                });
            });
        }
    }
});
